"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isomorphicFetch = _interopRequireDefault(require("isomorphic-fetch"));

var _Browser = require("acq-utils/lib/Browser");

var _fetch = _interopRequireDefault(require("acq-system-api/.dist/config/fetch"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function sendLog(log, url) {
  if (Array.isArray(log) && !log.length) {
    return;
  }

  var options = _objectSpread({}, _fetch.default, {
    body: JSON.stringify(log)
  });

  return (0, _isomorphicFetch.default)(url, options).then(function (response) {
    return response.json();
  });
}

;

function browserTransport(options) {
  var url = options.url,
      _options$batchRequest = options.batchRequests,
      batchRequests = _options$batchRequest === void 0 ? false : _options$batchRequest,
      _options$isProduction = options.isProduction,
      isProduction = _options$isProduction === void 0 ? false : _options$isProduction;
  var logs = [];

  window.onbeforeunload = function () {
    sendLog(logs, url);
  };

  return function browserLogger(log) {
    if (batchRequests) {
      logs.push(log);

      if (logs.length === 5) {
        sendLog(logs, url);
        logs.length = 0;
      }
    } else {
      sendLog(log, url);
    }

    if (!isProduction) {
      console.log(log); // eslint-disable-line no-console
    }
  };
}

var _default = (0, _Browser.ifBrowserThen)(browserTransport);

exports.default = _default;